import { render, staticRenderFns } from "./AddDataSegmentPopup.vue?vue&type=template&id=72a27020&"
import script from "./AddDataSegmentPopup.vue?vue&type=script&lang=js&"
export * from "./AddDataSegmentPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports